/* tslint:disable */
/* eslint-disable */
/**
 * ROC API
 * Referral Outbound Center (ROC) API for managing outbound referrals between post-acute care facilities.  All endpoints require a valid JWT. Organization and user identity are derived from the token — callers never pass these in query params or request bodies. 
 *
 * The version of the OpenAPI document: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Document
 */
export interface Document {
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    document_id: string;
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    referral_id: string;
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    document_type: string;
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    file_name: string;
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    s3_key: string;
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    content_type: string;
    /**
     * 
     * @type {number}
     * @memberof Document
     */
    file_size_bytes: number;
    /**
     * Page count when known (typically PDFs). Omitted when not applicable.
     * @type {number}
     * @memberof Document
     */
    page_count?: number;
    /**
     * SHA-256 hex digest of the originally uploaded blob, when supplied by the client.
     * @type {string}
     * @memberof Document
     */
    original_document_hash?: string;
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    uploaded_by_user_id: string;
    /**
     * 
     * @type {Date}
     * @memberof Document
     */
    created_at: Date;
}

/**
 * Check if a given object implements the Document interface.
 */
export function instanceOfDocument(value: object): value is Document {
    if (!('document_id' in value) || value['document_id'] === undefined) return false;
    if (!('referral_id' in value) || value['referral_id'] === undefined) return false;
    if (!('document_type' in value) || value['document_type'] === undefined) return false;
    if (!('file_name' in value) || value['file_name'] === undefined) return false;
    if (!('s3_key' in value) || value['s3_key'] === undefined) return false;
    if (!('content_type' in value) || value['content_type'] === undefined) return false;
    if (!('file_size_bytes' in value) || value['file_size_bytes'] === undefined) return false;
    if (!('uploaded_by_user_id' in value) || value['uploaded_by_user_id'] === undefined) return false;
    if (!('created_at' in value) || value['created_at'] === undefined) return false;
    return true;
}

export function DocumentFromJSON(json: any): Document {
    return DocumentFromJSONTyped(json, false);
}

export function DocumentFromJSONTyped(json: any, ignoreDiscriminator: boolean): Document {
    if (json == null) {
        return json;
    }
    return {
        
        'document_id': json['document_id'],
        'referral_id': json['referral_id'],
        'document_type': json['document_type'],
        'file_name': json['file_name'],
        's3_key': json['s3_key'],
        'content_type': json['content_type'],
        'file_size_bytes': json['file_size_bytes'],
        'page_count': json['page_count'] == null ? undefined : json['page_count'],
        'original_document_hash': json['original_document_hash'] == null ? undefined : json['original_document_hash'],
        'uploaded_by_user_id': json['uploaded_by_user_id'],
        'created_at': (new Date(json['created_at'])),
    };
}

export function DocumentToJSON(json: any): Document {
    return DocumentToJSONTyped(json, false);
}

export function DocumentToJSONTyped(value?: Document | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'document_id': value['document_id'],
        'referral_id': value['referral_id'],
        'document_type': value['document_type'],
        'file_name': value['file_name'],
        's3_key': value['s3_key'],
        'content_type': value['content_type'],
        'file_size_bytes': value['file_size_bytes'],
        'page_count': value['page_count'],
        'original_document_hash': value['original_document_hash'],
        'uploaded_by_user_id': value['uploaded_by_user_id'],
        'created_at': ((value['created_at']).toISOString()),
    };
}

